<div class="modal-header">
  <h5 class="modal-title" i18n>Charge</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div *ngIf="isDuplicate" class="mx-3 mt-3">
  <alert type="warning">
    <strong i18n>Warning:</strong>
    <ng-container i18n>This charge is a duplicate. Please modify the charge details, before clicking</ng-container>
    <strong i18n>Pay</strong> <ng-container i18n>to create the charge.</ng-container>
  </alert>
</div>

<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="row">
      <div class="col-md-6">
        <app-booking-select
          tooltipText="Associate this charge with an inquiry."
          i18n-tooltipText
          [ctrl]="form.get('inquiry_id')"
          [required]="true"
        ></app-booking-select>
      </div>

      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            matInput
            decimal
            required
            placeholder="Amount"
            i18n-placeholder
            formControlName="amount"
            type="number"
          />
          <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
            <ng-container i18n>Amount is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
    </div>

    <mat-form-field2 class="mat-block">
      <textarea
        matInput
        formControlName="description"
        #notes
        maxlength="500"
        rows="3"
        placeholder="Description"
        i18n-placeholder
        cdkTextareaAutosize
      ></textarea>
      <mat-hint align="end">{{ notes.value?.length || 0 }}/500</mat-hint>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>

  <button
    (click)="onSave(form)"
    [disabled]="(1 | isReadonlyRole) || isEdit || isLoading"
    type="button"
    class="btn btn-secondary-info"
  >
    <span class="cs-icon cs-icon-card" *ngIf="!isLoading"></span>
    <span class="far fa-spin fa-spinner" *ngIf="isLoading"></span>
    <ng-container i18n>Pay with Saved Card</ng-container>
  </button>
</div>
